var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyCart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6FF00"
    },
    d: "M92.066,361.435c0,0,43.091,54.564,116.722,56.784c73.631,2.22,139.479-43.679,193.806-79.457 c54.326-35.778,72.146-95.622,45.029-144.983c-27.117-49.361-76.348-32.471-135.469-67.178 c-59.12-34.707-69.599-52.924-138.137-49.805C105.479,79.915,48.75,153.135,51.249,235.169 C53.748,317.203,92.066,361.435,92.066,361.435z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    d: "M92.066,361.435c0,0,43.091,54.564,116.722,56.784 c73.631,2.22,139.479-43.679,193.806-79.457c54.326-35.778,72.146-95.622,45.029-144.983 c-27.117-49.361-76.348-32.471-135.469-67.178c-59.12-34.707-69.599-52.924-138.137-49.805 C105.479,79.915,48.75,153.135,51.249,235.169C53.748,317.203,92.066,361.435,92.066,361.435z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Products"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 91.025,
    y: 94.075,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 47.884,
    height: 57.646
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B2B2"
    },
    d: "M99.77,141.7v-16.699c-0.265,0.319-0.639,0.567-1.123,0.742 c-0.483,0.176-0.959,0.263-1.427,0.263v-2.327c0.663-0.093,1.292-0.362,1.889-0.807c0.596-0.444,1.05-1.033,1.362-1.766h2.432 V141.7H99.77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B2B2"
    },
    d: "M106.4,141.7v-2.877h2.631v2.877H106.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B2B2"
    },
    d: "M119.463,140.466c-0.694,0.979-1.774,1.468-3.239,1.468c-1.466,0-2.538-0.401-3.216-1.205 c-0.678-0.803-1.021-2.128-1.029-3.976v-1.122h2.958v0.433c0.008,1.271,0.096,2.119,0.263,2.543 c0.167,0.425,0.485,0.638,0.953,0.638c0.468,0,0.756-0.096,0.865-0.287c0.109-0.191,0.199-0.378,0.269-0.561 c0.07-0.183,0.105-0.789,0.105-1.818v-3.075c-0.429,0.288-1.064,0.433-1.906,0.433c-1.388,0-2.372-0.503-2.953-1.509 c-0.581-1.005-0.871-2.53-0.871-4.572v-0.748c0-2.557,0.44-4.276,1.321-5.157c0.717-0.717,1.74-1.076,3.07-1.076 c1.329,0,2.307,0.256,2.935,0.766c0.628,0.511,1.037,1.218,1.228,2.123c0.191,0.904,0.287,2.078,0.287,3.52v8.221 C120.503,137.833,120.157,139.488,119.463,140.466z M116.071,131.363c0.772,0,1.212-0.335,1.322-1.006v-3.906 c0-1.013-0.092-1.742-0.275-2.187c-0.183-0.444-0.534-0.667-1.053-0.667c-0.519,0-0.871,0.226-1.058,0.678 c-0.187,0.452-0.281,1.189-0.281,2.21v1.836c0,1.138,0.092,1.93,0.275,2.374C115.184,131.141,115.541,131.363,116.071,131.363z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B2B2"
    },
    d: "M130.583,140.466c-0.694,0.979-1.774,1.468-3.239,1.468c-1.466,0-2.538-0.401-3.216-1.205 c-0.678-0.803-1.021-2.128-1.029-3.976v-1.122h2.958v0.433c0.008,1.271,0.096,2.119,0.263,2.543 c0.167,0.425,0.485,0.638,0.953,0.638c0.468,0,0.756-0.096,0.865-0.287c0.109-0.191,0.199-0.378,0.269-0.561 c0.07-0.183,0.105-0.789,0.105-1.818v-3.075c-0.429,0.288-1.064,0.433-1.906,0.433c-1.388,0-2.372-0.503-2.953-1.509 c-0.581-1.005-0.871-2.53-0.871-4.572v-0.748c0-2.557,0.44-4.276,1.321-5.157c0.717-0.717,1.74-1.076,3.07-1.076 c1.329,0,2.307,0.256,2.935,0.766c0.627,0.511,1.037,1.218,1.228,2.123c0.191,0.904,0.287,2.078,0.287,3.52v8.221 C131.624,137.833,131.277,139.488,130.583,140.466z M127.192,131.363c0.772,0,1.212-0.335,1.322-1.006v-3.906 c0-1.013-0.092-1.742-0.275-2.187c-0.183-0.444-0.534-0.667-1.053-0.667s-0.871,0.226-1.058,0.678 c-0.187,0.452-0.281,1.189-0.281,2.21v1.836c0,1.138,0.092,1.93,0.275,2.374C126.305,131.141,126.662,131.363,127.192,131.363z "
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 97.533,
    y1: 117.32,
    x2: 131.935,
    y2: 117.32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 97.533,
    y1: 112.671,
    x2: 131.935,
    y2: 112.671
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 133.716,104.061 121.501,97.009 121.501,101.109 97.989,101.109 97.989,107.013 121.501,107.013 121.501,111.113  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 144.691,
    y: 124.93,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 50.559,
    height: 26.291
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 144.924,
    y1: 134.03,
    x2: 195.25,
    y2: 134.03
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 198.691,
    y: 124.93,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 50.559,
    height: 26.291
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 198.924,
    y1: 134.03,
    x2: 249.25,
    y2: 134.03
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 252.691,
    y: 124.93,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 50.559,
    height: 26.291
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 252.924,
    y1: 134.03,
    x2: 303.25,
    y2: 134.03
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 306.691,
    y: 124.93,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 50.559,
    height: 26.291
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 306.924,
    y1: 134.03,
    x2: 357.25,
    y2: 134.03
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 360.691,
    y: 124.93,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 50.559,
    height: 26.291
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 360.924,
    y1: 134.03,
    x2: 411.25,
    y2: 134.03
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 77.506,
    y1: 151.698,
    x2: 425.956,
    y2: 151.698
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 77.506,
    y1: 161.701,
    x2: 425.956,
    y2: 161.701
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 77.506,
    y1: 205.882,
    x2: 425.956,
    y2: 205.882
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 377.969,
    y: 216.169,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 47.884,
    height: 57.647
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B2B2"
    },
    d: "M386.714,263.795v-16.699c-0.265,0.319-0.639,0.567-1.122,0.742 c-0.483,0.176-0.959,0.263-1.427,0.263v-2.327c0.662-0.093,1.292-0.362,1.889-0.807c0.596-0.444,1.05-1.033,1.362-1.766h2.432 v20.594H386.714z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B2B2"
    },
    d: "M393.345,263.795v-2.877h2.631v2.877H393.345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B2B2"
    },
    d: "M406.407,262.56c-0.694,0.979-1.774,1.468-3.239,1.468c-1.466,0-2.538-0.401-3.216-1.204 c-0.679-0.803-1.021-2.129-1.029-3.977v-1.122h2.958v0.433c0.008,1.271,0.096,2.118,0.264,2.543 c0.167,0.426,0.485,0.638,0.953,0.638c0.468,0,0.756-0.096,0.865-0.286c0.109-0.191,0.198-0.378,0.268-0.561 c0.07-0.184,0.105-0.789,0.105-1.818v-3.075c-0.429,0.288-1.064,0.433-1.906,0.433c-1.388,0-2.372-0.503-2.952-1.509 c-0.581-1.006-0.871-2.53-0.871-4.573V249.2c0-2.557,0.439-4.276,1.321-5.157c0.717-0.717,1.74-1.076,3.069-1.076 s2.308,0.256,2.936,0.766c0.627,0.511,1.036,1.218,1.228,2.123c0.191,0.904,0.286,2.078,0.286,3.52v8.221 C407.447,259.928,407.101,261.583,406.407,262.56z M403.016,253.457c0.771,0,1.212-0.335,1.321-1.006v-3.906 c0-1.013-0.092-1.742-0.274-2.186c-0.184-0.444-0.534-0.667-1.053-0.667c-0.519,0-0.871,0.226-1.059,0.678 c-0.187,0.452-0.28,1.189-0.28,2.21v1.836c0,1.138,0.092,1.93,0.274,2.374C402.129,253.235,402.485,253.457,403.016,253.457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B2B2"
    },
    d: "M417.527,262.56c-0.694,0.979-1.773,1.468-3.239,1.468s-2.537-0.401-3.216-1.204 c-0.678-0.803-1.022-2.129-1.029-3.977v-1.122h2.959v0.433c0.008,1.271,0.096,2.118,0.263,2.543 c0.168,0.426,0.485,0.638,0.953,0.638c0.468,0,0.757-0.096,0.865-0.286c0.109-0.191,0.199-0.378,0.269-0.561 c0.07-0.184,0.106-0.789,0.106-1.818v-3.075c-0.43,0.288-1.064,0.433-1.906,0.433c-1.388,0-2.372-0.503-2.953-1.509 c-0.581-1.006-0.871-2.53-0.871-4.573V249.2c0-2.557,0.441-4.276,1.321-5.157c0.718-0.717,1.74-1.076,3.07-1.076 c1.329,0,2.307,0.256,2.935,0.766c0.628,0.511,1.037,1.218,1.228,2.123c0.191,0.904,0.287,2.078,0.287,3.52v8.221 C418.568,259.928,418.222,261.583,417.527,262.56z M414.136,253.457c0.773,0,1.213-0.335,1.322-1.006v-3.906 c0-1.013-0.092-1.742-0.275-2.186c-0.183-0.444-0.534-0.667-1.053-0.667c-0.519,0-0.871,0.226-1.058,0.678 c-0.188,0.452-0.281,1.189-0.281,2.21v1.836c0,1.138,0.092,1.93,0.275,2.374C413.249,253.235,413.606,253.457,414.136,253.457z "
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 384.477,
    y1: 239.414,
    x2: 418.879,
    y2: 239.414
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 384.477,
    y1: 234.765,
    x2: 418.879,
    y2: 234.765
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 420.66,226.155 408.445,219.103 408.445,223.203 384.933,223.203 384.933,229.107 408.445,229.107 408.445,233.208  "
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 77.506,
    y1: 215.886,
    x2: 425.956,
    y2: 215.886
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 77.506,
    y1: 260.299,
    x2: 375.753,
    y2: 260.299
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 77.506,
    y1: 270.303,
    x2: 375.753,
    y2: 270.303
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 77.506,
    y1: 314.252,
    x2: 425.956,
    y2: 314.252
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 77.506,
    y1: 324.255,
    x2: 425.956,
    y2: 324.255
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 77.506,
    y1: 368.436,
    x2: 425.956,
    y2: 368.436
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 77.506,
    y1: 378.44,
    x2: 425.956,
    y2: 378.44
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 91.483,
    y: 167.082,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 18.784,
    height: 38.804
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.598,
    y: 169.492,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 9.718,
    height: 25.67
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 95.415,
    y1: 198.646,
    x2: 105.5,
    y2: 198.646
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 95.415,
    y1: 201.763,
    x2: 105.5,
    y2: 201.763
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 111.652,
    y: 167.082,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 18.784,
    height: 38.804
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.768,
    y: 169.492,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 9.718,
    height: 25.67
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 115.584,
    y1: 198.646,
    x2: 125.669,
    y2: 198.646
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 115.584,
    y1: 201.763,
    x2: 125.669,
    y2: 201.763
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 131.822,
    y: 167.082,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 18.784,
    height: 38.804
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.937,
    y: 169.492,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 9.718,
    height: 25.67
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 135.754,
    y1: 198.646,
    x2: 145.839,
    y2: 198.646
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 135.754,
    y1: 201.763,
    x2: 145.839,
    y2: 201.763
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 151.991,
    y: 167.082,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 18.784,
    height: 38.804
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.107,
    y: 169.492,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 9.718,
    height: 25.67
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 155.923,
    y1: 198.646,
    x2: 166.008,
    y2: 198.646
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 155.923,
    y1: 201.763,
    x2: 166.008,
    y2: 201.763
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 172.161,
    y: 167.082,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 18.784,
    height: 38.804
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.276,
    y: 169.492,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 9.718,
    height: 25.67
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 176.093,
    y1: 198.646,
    x2: 186.177,
    y2: 198.646
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 176.093,
    y1: 201.763,
    x2: 186.177,
    y2: 201.763
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 192.33,
    y: 167.082,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 18.784,
    height: 38.804
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.445,
    y: 169.492,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 9.718,
    height: 25.67
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 196.262,
    y1: 198.646,
    x2: 206.347,
    y2: 198.646
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 196.262,
    y1: 201.763,
    x2: 206.347,
    y2: 201.763
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 212.5,
    y: 167.082,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 18.784,
    height: 38.804
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.615,
    y: 169.492,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 9.718,
    height: 25.67
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 216.431,
    y1: 198.646,
    x2: 226.516,
    y2: 198.646
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 216.431,
    y1: 201.763,
    x2: 226.516,
    y2: 201.763
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 232.669,
    y: 167.082,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 18.784,
    height: 38.804
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.784,
    y: 169.492,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 9.718,
    height: 25.67
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 236.601,
    y1: 198.646,
    x2: 246.686,
    y2: 198.646
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 236.601,
    y1: 201.763,
    x2: 246.686,
    y2: 201.763
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 252.838,
    y: 167.082,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 18.784,
    height: 38.804
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.954,
    y: 169.492,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 9.718,
    height: 25.67
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 256.77,
    y1: 198.646,
    x2: 266.855,
    y2: 198.646
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 256.77,
    y1: 201.763,
    x2: 266.855,
    y2: 201.763
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 273.008,
    y: 167.082,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 18.784,
    height: 38.804
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.123,
    y: 169.492,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 9.718,
    height: 25.67
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 276.94,
    y1: 198.646,
    x2: 287.025,
    y2: 198.646
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 276.94,
    y1: 201.763,
    x2: 287.025,
    y2: 201.763
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 293.177,
    y: 167.082,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 18.784,
    height: 38.804
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.293,
    y: 169.492,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 9.718,
    height: 25.67
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 297.109,
    y1: 198.646,
    x2: 307.194,
    y2: 198.646
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 297.109,
    y1: 201.763,
    x2: 307.194,
    y2: 201.763
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 313.347,
    y: 167.082,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 18.784,
    height: 38.804
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.462,
    y: 169.492,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 9.718,
    height: 25.67
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 317.279,
    y1: 198.646,
    x2: 327.363,
    y2: 198.646
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 317.279,
    y1: 201.763,
    x2: 327.363,
    y2: 201.763
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 333.516,
    y: 167.082,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 18.784,
    height: 38.804
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.631,
    y: 169.492,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 9.718,
    height: 25.67
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 337.448,
    y1: 198.646,
    x2: 347.533,
    y2: 198.646
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 337.448,
    y1: 201.763,
    x2: 347.533,
    y2: 201.763
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 353.686,
    y: 167.082,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 18.784,
    height: 38.804
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.801,
    y: 169.492,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 9.718,
    height: 25.67
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 357.617,
    y1: 198.646,
    x2: 367.702,
    y2: 198.646
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 357.617,
    y1: 201.763,
    x2: 367.702,
    y2: 201.763
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 373.855,
    y: 167.082,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 18.784,
    height: 38.804
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.97,
    y: 169.492,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 9.718,
    height: 25.67
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 377.787,
    y1: 198.646,
    x2: 387.872,
    y2: 198.646
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 377.787,
    y1: 201.763,
    x2: 387.872,
    y2: 201.763
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 394.024,
    y: 167.082,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 18.784,
    height: 38.804
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.14,
    y: 169.492,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 9.718,
    height: 25.67
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 397.956,
    y1: 198.646,
    x2: 408.041,
    y2: 198.646
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 397.956,
    y1: 201.763,
    x2: 408.041,
    y2: 201.763
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 94.877,
    y: 239.424,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 14.559,
    height: 20.798
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 95.439,
    y1: 241.783,
    x2: 109.342,
    y2: 241.783
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 95.439,
    y1: 258.063,
    x2: 109.342,
    y2: 258.063
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 102.116,
    cy: 249.374,
    r: 4.848
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 111.127,
    y: 239.424,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 14.559,
    height: 20.798
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 111.689,
    y1: 241.783,
    x2: 125.592,
    y2: 241.783
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 111.689,
    y1: 258.063,
    x2: 125.592,
    y2: 258.063
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 118.366,
    cy: 249.374,
    r: 4.848
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 127.377,
    y: 239.424,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 14.559,
    height: 20.798
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 127.939,
    y1: 241.783,
    x2: 141.842,
    y2: 241.783
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 127.939,
    y1: 258.063,
    x2: 141.842,
    y2: 258.063
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 134.616,
    cy: 249.374,
    r: 4.848
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 143.627,
    y: 239.424,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 14.559,
    height: 20.798
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 144.189,
    y1: 241.783,
    x2: 158.092,
    y2: 241.783
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 144.189,
    y1: 258.063,
    x2: 158.092,
    y2: 258.063
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 150.866,
    cy: 249.374,
    r: 4.848
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 159.877,
    y: 239.424,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 14.559,
    height: 20.798
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 160.439,
    y1: 241.783,
    x2: 174.342,
    y2: 241.783
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 160.439,
    y1: 258.063,
    x2: 174.342,
    y2: 258.063
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 167.116,
    cy: 249.374,
    r: 4.848
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 176.127,
    y: 239.424,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 14.559,
    height: 20.798
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 176.689,
    y1: 241.783,
    x2: 190.592,
    y2: 241.783
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 176.689,
    y1: 258.063,
    x2: 190.592,
    y2: 258.063
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 183.366,
    cy: 249.374,
    r: 4.848
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 192.377,
    y: 239.424,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 14.559,
    height: 20.798
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 192.939,
    y1: 241.783,
    x2: 206.842,
    y2: 241.783
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 192.939,
    y1: 258.063,
    x2: 206.842,
    y2: 258.063
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 199.616,
    cy: 249.374,
    r: 4.848
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 101.913,
    y: 218.299,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 14.559,
    height: 20.798
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 102.475,
    y1: 220.658,
    x2: 116.378,
    y2: 220.658
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 102.475,
    y1: 236.939,
    x2: 116.378,
    y2: 236.939
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 109.152,
    cy: 228.25,
    r: 4.848
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 118.163,
    y: 218.299,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 14.559,
    height: 20.798
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 118.725,
    y1: 220.658,
    x2: 132.628,
    y2: 220.658
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 118.725,
    y1: 236.939,
    x2: 132.628,
    y2: 236.939
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 125.402,
    cy: 228.25,
    r: 4.848
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 134.413,
    y: 218.299,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 14.559,
    height: 20.798
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 134.975,
    y1: 220.658,
    x2: 148.878,
    y2: 220.658
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 134.975,
    y1: 236.939,
    x2: 148.878,
    y2: 236.939
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 141.652,
    cy: 228.25,
    r: 4.848
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 150.663,
    y: 218.299,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 14.559,
    height: 20.798
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 151.225,
    y1: 220.658,
    x2: 165.128,
    y2: 220.658
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 151.225,
    y1: 236.939,
    x2: 165.128,
    y2: 236.939
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 157.902,
    cy: 228.25,
    r: 4.848
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 166.913,
    y: 218.299,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 14.559,
    height: 20.798
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 167.475,
    y1: 220.658,
    x2: 181.378,
    y2: 220.658
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 167.475,
    y1: 236.939,
    x2: 181.378,
    y2: 236.939
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 174.152,
    cy: 228.25,
    r: 4.848
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 183.163,
    y: 218.299,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 14.559,
    height: 20.798
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 183.725,
    y1: 220.658,
    x2: 197.628,
    y2: 220.658
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 183.725,
    y1: 236.939,
    x2: 197.628,
    y2: 236.939
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 190.402,
    cy: 228.25,
    r: 4.848
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 208.374,
    y: 239.424,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 14.559,
    height: 20.798
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 208.936,
    y1: 241.783,
    x2: 222.839,
    y2: 241.783
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 208.936,
    y1: 258.063,
    x2: 222.839,
    y2: 258.063
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 215.613,
    cy: 249.374,
    r: 4.848
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 224.624,
    y: 239.424,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 14.559,
    height: 20.798
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 225.186,
    y1: 241.783,
    x2: 239.089,
    y2: 241.783
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 225.186,
    y1: 258.063,
    x2: 239.089,
    y2: 258.063
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 231.863,
    cy: 249.374,
    r: 4.848
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 240.874,
    y: 239.424,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 14.559,
    height: 20.798
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 241.436,
    y1: 241.783,
    x2: 255.339,
    y2: 241.783
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 241.436,
    y1: 258.063,
    x2: 255.339,
    y2: 258.063
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 248.113,
    cy: 249.374,
    r: 4.848
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 257.124,
    y: 239.424,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 14.559,
    height: 20.798
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 257.686,
    y1: 241.783,
    x2: 271.589,
    y2: 241.783
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 257.686,
    y1: 258.063,
    x2: 271.589,
    y2: 258.063
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 264.363,
    cy: 249.374,
    r: 4.848
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 273.374,
    y: 239.424,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 14.559,
    height: 20.798
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 273.936,
    y1: 241.783,
    x2: 287.839,
    y2: 241.783
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 273.936,
    y1: 258.063,
    x2: 287.839,
    y2: 258.063
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 280.613,
    cy: 249.374,
    r: 4.848
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 289.624,
    y: 239.424,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 14.559,
    height: 20.798
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 290.186,
    y1: 241.783,
    x2: 304.089,
    y2: 241.783
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 290.186,
    y1: 258.063,
    x2: 304.089,
    y2: 258.063
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 296.863,
    cy: 249.374,
    r: 4.848
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 199.16,
    y: 218.299,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 14.559,
    height: 20.798
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 199.722,
    y1: 220.658,
    x2: 213.625,
    y2: 220.658
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 199.722,
    y1: 236.939,
    x2: 213.625,
    y2: 236.939
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 206.399,
    cy: 228.25,
    r: 4.848
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 215.41,
    y: 218.299,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 14.559,
    height: 20.798
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 215.972,
    y1: 220.658,
    x2: 229.875,
    y2: 220.658
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 215.972,
    y1: 236.939,
    x2: 229.875,
    y2: 236.939
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 222.649,
    cy: 228.25,
    r: 4.848
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 231.66,
    y: 218.299,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 14.559,
    height: 20.798
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 232.222,
    y1: 220.658,
    x2: 246.125,
    y2: 220.658
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 232.222,
    y1: 236.939,
    x2: 246.125,
    y2: 236.939
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 238.899,
    cy: 228.25,
    r: 4.848
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 247.91,
    y: 218.299,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 14.559,
    height: 20.798
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 248.472,
    y1: 220.658,
    x2: 262.375,
    y2: 220.658
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 248.472,
    y1: 236.939,
    x2: 262.375,
    y2: 236.939
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 255.149,
    cy: 228.25,
    r: 4.848
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 264.16,
    y: 218.299,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 14.559,
    height: 20.798
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 264.723,
    y1: 220.658,
    x2: 278.625,
    y2: 220.658
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 264.723,
    y1: 236.939,
    x2: 278.625,
    y2: 236.939
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 271.399,
    cy: 228.25,
    r: 4.848
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 280.41,
    y: 218.299,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 14.559,
    height: 20.798
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 280.973,
    y1: 220.658,
    x2: 294.875,
    y2: 220.658
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 280.973,
    y1: 236.939,
    x2: 294.875,
    y2: 236.939
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 287.649,
    cy: 228.25,
    r: 4.848
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 305.621,
    y: 239.424,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 14.559,
    height: 20.798
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 306.184,
    y1: 241.783,
    x2: 320.086,
    y2: 241.783
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 306.184,
    y1: 258.063,
    x2: 320.086,
    y2: 258.063
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 312.86,
    cy: 249.374,
    r: 4.848
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 321.871,
    y: 239.424,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 14.559,
    height: 20.798
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 322.434,
    y1: 241.783,
    x2: 336.336,
    y2: 241.783
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 322.434,
    y1: 258.063,
    x2: 336.336,
    y2: 258.063
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 329.11,
    cy: 249.374,
    r: 4.848
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 338.121,
    y: 239.424,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 14.559,
    height: 20.798
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 338.684,
    y1: 241.783,
    x2: 352.586,
    y2: 241.783
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 338.684,
    y1: 258.063,
    x2: 352.586,
    y2: 258.063
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 345.36,
    cy: 249.374,
    r: 4.848
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 354.371,
    y: 239.424,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 14.559,
    height: 20.798
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 354.934,
    y1: 241.783,
    x2: 368.836,
    y2: 241.783
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 354.934,
    y1: 258.063,
    x2: 368.836,
    y2: 258.063
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 361.61,
    cy: 249.374,
    r: 4.848
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 296.407,
    y: 218.299,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 14.559,
    height: 20.798
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 296.969,
    y1: 220.658,
    x2: 310.872,
    y2: 220.658
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 296.969,
    y1: 236.939,
    x2: 310.872,
    y2: 236.939
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 303.646,
    cy: 228.25,
    r: 4.848
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 312.657,
    y: 218.299,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 14.559,
    height: 20.798
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 313.219,
    y1: 220.658,
    x2: 327.122,
    y2: 220.658
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 313.219,
    y1: 236.939,
    x2: 327.122,
    y2: 236.939
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 319.896,
    cy: 228.25,
    r: 4.848
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 328.907,
    y: 218.299,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 14.559,
    height: 20.798
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 329.469,
    y1: 220.658,
    x2: 343.372,
    y2: 220.658
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 329.469,
    y1: 236.939,
    x2: 343.372,
    y2: 236.939
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 336.146,
    cy: 228.25,
    r: 4.848
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 345.157,
    y: 218.299,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 14.559,
    height: 20.798
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 345.719,
    y1: 220.658,
    x2: 359.622,
    y2: 220.658
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 345.719,
    y1: 236.939,
    x2: 359.622,
    y2: 236.939
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 352.396,
    cy: 228.25,
    r: 4.848
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 96.265,314.118 81.411,314.118 79.926,300.482 97.75,300.482  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.733,
    y: 298.534,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 19.989,
    height: 1.939
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 118.598,314.118 103.745,314.118 102.259,300.482 120.083,300.482  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.066,
    y: 298.534,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 19.989,
    height: 1.939
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 140.931,314.118 126.078,314.118 124.593,300.482 142.417,300.482  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.399,
    y: 298.534,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 19.989,
    height: 1.939
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 163.265,314.118 148.411,314.118 146.926,300.482 164.75,300.482  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.733,
    y: 298.534,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 19.989,
    height: 1.939
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 185.598,314.118 170.745,314.118 169.259,300.482 187.083,300.482  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.066,
    y: 298.534,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 19.989,
    height: 1.939
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 207.931,314.118 193.078,314.118 191.593,300.482 209.417,300.482  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.399,
    y: 298.534,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 19.989,
    height: 1.939
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 230.265,314.118 215.411,314.118 213.926,300.482 231.75,300.482  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.733,
    y: 298.534,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 19.989,
    height: 1.939
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 252.598,314.118 237.745,314.118 236.259,300.482 254.083,300.482  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.066,
    y: 298.534,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 19.989,
    height: 1.939
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 274.931,314.118 260.078,314.118 258.593,300.482 276.417,300.482  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.399,
    y: 298.534,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 19.989,
    height: 1.939
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 297.265,314.118 282.411,314.118 280.926,300.482 298.75,300.482  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.733,
    y: 298.534,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 19.989,
    height: 1.939
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 319.598,314.118 304.745,314.118 303.259,300.482 321.083,300.482  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.066,
    y: 298.534,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 19.989,
    height: 1.939
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 341.931,314.118 327.078,314.118 325.593,300.482 343.417,300.482  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.399,
    y: 298.534,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 19.989,
    height: 1.939
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 364.265,314.118 349.411,314.118 347.926,300.482 365.75,300.482  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.733,
    y: 298.534,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 19.989,
    height: 1.939
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 386.598,314.118 371.745,314.118 370.259,300.482 388.083,300.482  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.066,
    y: 298.534,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 19.989,
    height: 1.939
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 408.931,314.118 394.078,314.118 392.593,300.482 410.417,300.482  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.399,
    y: 298.534,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 19.989,
    height: 1.939
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 107.254,298.001 92.4,298.001 90.915,284.365 108.739,284.365  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.722,
    y: 282.417,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 19.989,
    height: 1.939
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 129.587,298.001 114.734,298.001 113.248,284.365 131.072,284.365  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.055,
    y: 282.417,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 19.989,
    height: 1.939
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 151.92,298.001 137.067,298.001 135.582,284.365 153.406,284.365  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.388,
    y: 282.417,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 19.989,
    height: 1.939
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 174.254,298.001 159.4,298.001 157.915,284.365 175.739,284.365  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.722,
    y: 282.417,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 19.989,
    height: 1.939
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 196.587,298.001 181.734,298.001 180.248,284.365 198.072,284.365  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.055,
    y: 282.417,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 19.989,
    height: 1.939
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 218.92,298.001 204.067,298.001 202.582,284.365 220.406,284.365  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.388,
    y: 282.417,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 19.989,
    height: 1.939
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 241.254,298.001 226.4,298.001 224.915,284.365 242.739,284.365  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.722,
    y: 282.417,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 19.989,
    height: 1.939
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 263.587,298.001 248.734,298.001 247.248,284.365 265.072,284.365  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.055,
    y: 282.417,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 19.989,
    height: 1.939
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 285.92,298.001 271.067,298.001 269.582,284.365 287.406,284.365  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.388,
    y: 282.417,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 19.989,
    height: 1.939
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 308.254,298.001 293.4,298.001 291.915,284.365 309.739,284.365  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.722,
    y: 282.417,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 19.989,
    height: 1.939
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 330.587,298.001 315.734,298.001 314.248,284.365 332.072,284.365  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.055,
    y: 282.417,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 19.989,
    height: 1.939
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 352.92,298.001 338.067,298.001 336.582,284.365 354.406,284.365  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.388,
    y: 282.417,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 19.989,
    height: 1.939
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 375.254,298.001 360.4,298.001 358.915,284.365 376.739,284.365  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.722,
    y: 282.417,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 19.989,
    height: 1.939
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 397.587,298.001 382.734,298.001 381.248,284.365 399.072,284.365  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380.055,
    y: 282.417,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 19.989,
    height: 1.939
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M99.369,351.641 h-7.575c-1.45,0-2.625,1.175-2.625,2.625v13.972h12.825v-13.972C101.994,352.816,100.818,351.641,99.369,351.641z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.13,
    y: 349.981,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.902,
    height: 1.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.697,
    y: 348.02,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 11.769,
    height: 1.962
  })), /*#__PURE__*/React.createElement("rect", {
    x: 90.451,
    y: 354.508,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 10.26,
    height: 11.015
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M114.048,351.641 h-7.575c-1.45,0-2.625,1.175-2.625,2.625v13.972h12.825v-13.972C116.673,352.816,115.498,351.641,114.048,351.641z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.809,
    y: 349.981,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.902,
    height: 1.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.376,
    y: 348.02,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 11.769,
    height: 1.962
  })), /*#__PURE__*/React.createElement("rect", {
    x: 105.13,
    y: 354.508,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 10.26,
    height: 11.015
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M128.727,351.641 h-7.575c-1.45,0-2.625,1.175-2.625,2.625v13.972h12.825v-13.972C131.352,352.816,130.177,351.641,128.727,351.641z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.488,
    y: 349.981,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.902,
    height: 1.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.055,
    y: 348.02,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 11.769,
    height: 1.962
  })), /*#__PURE__*/React.createElement("rect", {
    x: 119.809,
    y: 354.508,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 10.26,
    height: 11.015
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M143.406,351.641 h-7.575c-1.45,0-2.625,1.175-2.625,2.625v13.972h12.825v-13.972C146.032,352.816,144.856,351.641,143.406,351.641z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.168,
    y: 349.981,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.902,
    height: 1.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.734,
    y: 348.02,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 11.769,
    height: 1.962
  })), /*#__PURE__*/React.createElement("rect", {
    x: 134.489,
    y: 354.508,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 10.26,
    height: 11.015
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M158.086,351.641 h-7.575c-1.45,0-2.625,1.175-2.625,2.625v13.972h12.825v-13.972C160.711,352.816,159.536,351.641,158.086,351.641z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.847,
    y: 349.981,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.902,
    height: 1.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.414,
    y: 348.02,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 11.769,
    height: 1.962
  })), /*#__PURE__*/React.createElement("rect", {
    x: 149.168,
    y: 354.508,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 10.26,
    height: 11.015
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M172.765,351.641 h-7.575c-1.45,0-2.625,1.175-2.625,2.625v13.972h12.825v-13.972C175.39,352.816,174.215,351.641,172.765,351.641z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.526,
    y: 349.981,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.902,
    height: 1.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.093,
    y: 348.02,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 11.769,
    height: 1.962
  })), /*#__PURE__*/React.createElement("rect", {
    x: 163.847,
    y: 354.508,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 10.26,
    height: 11.015
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M187.444,351.641 h-7.575c-1.45,0-2.625,1.175-2.625,2.625v13.972h12.825v-13.972C190.069,352.816,188.894,351.641,187.444,351.641z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.206,
    y: 349.981,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.902,
    height: 1.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.772,
    y: 348.02,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 11.769,
    height: 1.962
  })), /*#__PURE__*/React.createElement("rect", {
    x: 178.527,
    y: 354.508,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 10.26,
    height: 11.015
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M202.124,351.641 h-7.575c-1.45,0-2.625,1.175-2.625,2.625v13.972h12.825v-13.972C204.749,352.816,203.573,351.641,202.124,351.641z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.885,
    y: 349.981,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.902,
    height: 1.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.451,
    y: 348.02,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 11.769,
    height: 1.962
  })), /*#__PURE__*/React.createElement("rect", {
    x: 193.206,
    y: 354.508,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 10.26,
    height: 11.015
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M216.803,351.641 h-7.575c-1.45,0-2.625,1.175-2.625,2.625v13.972h12.825v-13.972C219.428,352.816,218.253,351.641,216.803,351.641z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.564,
    y: 349.981,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.902,
    height: 1.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.131,
    y: 348.02,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 11.769,
    height: 1.962
  })), /*#__PURE__*/React.createElement("rect", {
    x: 207.885,
    y: 354.508,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 10.26,
    height: 11.015
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M231.482,351.641 h-7.575c-1.45,0-2.625,1.175-2.625,2.625v13.972h12.825v-13.972C234.107,352.816,232.932,351.641,231.482,351.641z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.243,
    y: 349.981,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.902,
    height: 1.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.81,
    y: 348.02,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 11.769,
    height: 1.962
  })), /*#__PURE__*/React.createElement("rect", {
    x: 222.564,
    y: 354.508,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 10.26,
    height: 11.015
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M246.161,351.641 h-7.575c-1.45,0-2.625,1.175-2.625,2.625v13.972h12.825v-13.972C248.786,352.816,247.611,351.641,246.161,351.641z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.923,
    y: 349.981,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.902,
    height: 1.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.489,
    y: 348.02,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 11.769,
    height: 1.962
  })), /*#__PURE__*/React.createElement("rect", {
    x: 237.244,
    y: 354.508,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 10.26,
    height: 11.015
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M260.841,351.641 h-7.575c-1.45,0-2.625,1.175-2.625,2.625v13.972h12.825v-13.972C263.466,352.816,262.29,351.641,260.841,351.641z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.602,
    y: 349.981,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.902,
    height: 1.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.168,
    y: 348.02,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 11.769,
    height: 1.962
  })), /*#__PURE__*/React.createElement("rect", {
    x: 251.923,
    y: 354.508,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 10.26,
    height: 11.015
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M275.52,351.641 h-7.575c-1.45,0-2.625,1.175-2.625,2.625v13.972h12.825v-13.972C278.145,352.816,276.97,351.641,275.52,351.641z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.281,
    y: 349.981,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.902,
    height: 1.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.848,
    y: 348.02,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 11.769,
    height: 1.962
  })), /*#__PURE__*/React.createElement("rect", {
    x: 266.602,
    y: 354.508,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 10.26,
    height: 11.015
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M290.199,351.641 h-7.575c-1.45,0-2.625,1.175-2.625,2.625v13.972h12.825v-13.972C292.824,352.816,291.649,351.641,290.199,351.641z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.96,
    y: 349.981,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.902,
    height: 1.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.527,
    y: 348.02,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 11.769,
    height: 1.962
  })), /*#__PURE__*/React.createElement("rect", {
    x: 281.281,
    y: 354.508,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 10.26,
    height: 11.015
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M304.878,351.641 h-7.575c-1.45,0-2.625,1.175-2.625,2.625v13.972h12.825v-13.972C307.504,352.816,306.328,351.641,304.878,351.641z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.64,
    y: 349.981,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.902,
    height: 1.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.206,
    y: 348.02,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 11.769,
    height: 1.962
  })), /*#__PURE__*/React.createElement("rect", {
    x: 295.961,
    y: 354.508,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 10.26,
    height: 11.015
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M319.558,351.641 h-7.575c-1.45,0-2.625,1.175-2.625,2.625v13.972h12.825v-13.972C322.183,352.816,321.008,351.641,319.558,351.641z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.319,
    y: 349.981,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.902,
    height: 1.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.886,
    y: 348.02,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 11.769,
    height: 1.962
  })), /*#__PURE__*/React.createElement("rect", {
    x: 310.64,
    y: 354.508,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 10.26,
    height: 11.015
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M334.237,351.641 h-7.575c-1.45,0-2.625,1.175-2.625,2.625v13.972h12.825v-13.972C336.862,352.816,335.687,351.641,334.237,351.641z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.998,
    y: 349.981,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.902,
    height: 1.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.565,
    y: 348.02,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 11.769,
    height: 1.962
  })), /*#__PURE__*/React.createElement("rect", {
    x: 325.319,
    y: 354.508,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 10.26,
    height: 11.015
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M348.916,351.641 h-7.575c-1.45,0-2.625,1.175-2.625,2.625v13.972h12.825v-13.972C351.542,352.816,350.366,351.641,348.916,351.641z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.678,
    y: 349.981,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.902,
    height: 1.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.244,
    y: 348.02,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 11.769,
    height: 1.962
  })), /*#__PURE__*/React.createElement("rect", {
    x: 339.999,
    y: 354.508,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 10.26,
    height: 11.015
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M105.806,331.121 h-7.575c-1.45,0-2.625,1.175-2.625,2.625v13.972h12.825v-13.972C108.431,332.297,107.256,331.121,105.806,331.121z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.567,
    y: 329.461,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.902,
    height: 1.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.134,
    y: 327.5,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 11.769,
    height: 1.962
  })), /*#__PURE__*/React.createElement("rect", {
    x: 96.888,
    y: 333.988,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 10.26,
    height: 11.015
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M120.485,331.121 h-7.575c-1.45,0-2.625,1.175-2.625,2.625v13.972h12.825v-13.972C123.111,332.297,121.935,331.121,120.485,331.121z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.247,
    y: 329.461,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.902,
    height: 1.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.813,
    y: 327.5,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 11.769,
    height: 1.962
  })), /*#__PURE__*/React.createElement("rect", {
    x: 111.568,
    y: 333.988,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 10.26,
    height: 11.015
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M135.165,331.121 h-7.575c-1.45,0-2.625,1.175-2.625,2.625v13.972h12.825v-13.972C137.79,332.297,136.615,331.121,135.165,331.121z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.926,
    y: 329.461,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.902,
    height: 1.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.493,
    y: 327.5,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 11.769,
    height: 1.962
  })), /*#__PURE__*/React.createElement("rect", {
    x: 126.247,
    y: 333.988,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 10.26,
    height: 11.015
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M149.844,331.121 h-7.575c-1.45,0-2.625,1.175-2.625,2.625v13.972h12.825v-13.972C152.469,332.297,151.294,331.121,149.844,331.121z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.605,
    y: 329.461,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.902,
    height: 1.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.172,
    y: 327.5,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 11.769,
    height: 1.962
  })), /*#__PURE__*/React.createElement("rect", {
    x: 140.926,
    y: 333.988,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 10.26,
    height: 11.015
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M164.523,331.121 h-7.575c-1.45,0-2.625,1.175-2.625,2.625v13.972h12.825v-13.972C167.148,332.297,165.973,331.121,164.523,331.121z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.285,
    y: 329.461,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.902,
    height: 1.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.851,
    y: 327.5,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 11.769,
    height: 1.962
  })), /*#__PURE__*/React.createElement("rect", {
    x: 155.606,
    y: 333.988,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 10.26,
    height: 11.015
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M179.203,331.121 h-7.575c-1.45,0-2.625,1.175-2.625,2.625v13.972h12.825v-13.972C181.828,332.297,180.652,331.121,179.203,331.121z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.964,
    y: 329.461,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.902,
    height: 1.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.53,
    y: 327.5,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 11.769,
    height: 1.962
  })), /*#__PURE__*/React.createElement("rect", {
    x: 170.285,
    y: 333.988,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 10.26,
    height: 11.015
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M193.882,331.121 h-7.575c-1.45,0-2.625,1.175-2.625,2.625v13.972h12.825v-13.972C196.507,332.297,195.332,331.121,193.882,331.121z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.643,
    y: 329.461,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.902,
    height: 1.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.21,
    y: 327.5,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 11.769,
    height: 1.962
  })), /*#__PURE__*/React.createElement("rect", {
    x: 184.964,
    y: 333.988,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 10.26,
    height: 11.015
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M208.561,331.121 h-7.575c-1.45,0-2.625,1.175-2.625,2.625v13.972h12.825v-13.972C211.186,332.297,210.011,331.121,208.561,331.121z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.322,
    y: 329.461,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.902,
    height: 1.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.889,
    y: 327.5,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 11.769,
    height: 1.962
  })), /*#__PURE__*/React.createElement("rect", {
    x: 199.643,
    y: 333.988,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 10.26,
    height: 11.015
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M223.24,331.121 h-7.575c-1.45,0-2.625,1.175-2.625,2.625v13.972h12.825v-13.972C225.865,332.297,224.69,331.121,223.24,331.121z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.002,
    y: 329.461,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.902,
    height: 1.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.568,
    y: 327.5,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 11.769,
    height: 1.962
  })), /*#__PURE__*/React.createElement("rect", {
    x: 214.323,
    y: 333.988,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 10.26,
    height: 11.015
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M237.92,331.121 h-7.575c-1.45,0-2.625,1.175-2.625,2.625v13.972h12.825v-13.972C240.545,332.297,239.369,331.121,237.92,331.121z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.681,
    y: 329.461,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.902,
    height: 1.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.247,
    y: 327.5,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 11.769,
    height: 1.962
  })), /*#__PURE__*/React.createElement("rect", {
    x: 229.002,
    y: 333.988,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 10.26,
    height: 11.015
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M252.599,331.121 h-7.575c-1.45,0-2.625,1.175-2.625,2.625v13.972h12.825v-13.972C255.224,332.297,254.049,331.121,252.599,331.121z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.36,
    y: 329.461,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.902,
    height: 1.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.927,
    y: 327.5,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 11.769,
    height: 1.962
  })), /*#__PURE__*/React.createElement("rect", {
    x: 243.681,
    y: 333.988,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 10.26,
    height: 11.015
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M267.278,331.121 h-7.575c-1.45,0-2.625,1.175-2.625,2.625v13.972h12.825v-13.972C269.903,332.297,268.728,331.121,267.278,331.121z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.039,
    y: 329.461,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.902,
    height: 1.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.606,
    y: 327.5,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 11.769,
    height: 1.962
  })), /*#__PURE__*/React.createElement("rect", {
    x: 258.361,
    y: 333.988,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 10.26,
    height: 11.015
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M281.957,331.121 h-7.575c-1.45,0-2.625,1.175-2.625,2.625v13.972h12.825v-13.972C284.583,332.297,283.407,331.121,281.957,331.121z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.719,
    y: 329.461,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.902,
    height: 1.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.285,
    y: 327.5,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 11.769,
    height: 1.962
  })), /*#__PURE__*/React.createElement("rect", {
    x: 273.04,
    y: 333.988,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 10.26,
    height: 11.015
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M296.637,331.121 h-7.575c-1.45,0-2.625,1.175-2.625,2.625v13.972h12.825v-13.972C299.262,332.297,298.087,331.121,296.637,331.121z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.398,
    y: 329.461,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.902,
    height: 1.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.965,
    y: 327.5,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 11.769,
    height: 1.962
  })), /*#__PURE__*/React.createElement("rect", {
    x: 287.719,
    y: 333.988,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 10.26,
    height: 11.015
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M311.316,331.121 h-7.575c-1.45,0-2.625,1.175-2.625,2.625v13.972h12.825v-13.972C313.941,332.297,312.766,331.121,311.316,331.121z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.077,
    y: 329.461,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.902,
    height: 1.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.644,
    y: 327.5,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 11.769,
    height: 1.962
  })), /*#__PURE__*/React.createElement("rect", {
    x: 302.398,
    y: 333.988,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 10.26,
    height: 11.015
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M325.995,331.121 h-7.575c-1.45,0-2.625,1.175-2.625,2.625v13.972h12.825v-13.972C328.62,332.297,327.445,331.121,325.995,331.121z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.757,
    y: 329.461,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.902,
    height: 1.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.323,
    y: 327.5,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 11.769,
    height: 1.962
  })), /*#__PURE__*/React.createElement("rect", {
    x: 317.078,
    y: 333.988,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 10.26,
    height: 11.015
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M340.675,331.121 h-7.575c-1.45,0-2.625,1.175-2.625,2.625v13.972H343.3v-13.972C343.3,332.297,342.124,331.121,340.675,331.121z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.436,
    y: 329.461,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.902,
    height: 1.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.003,
    y: 327.5,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 11.769,
    height: 1.962
  })), /*#__PURE__*/React.createElement("rect", {
    x: 331.757,
    y: 333.988,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 10.26,
    height: 11.015
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M363.676,351.641 H356.1c-1.45,0-2.625,1.175-2.625,2.625v13.972h12.825v-13.972C366.301,352.816,365.125,351.641,363.676,351.641z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.437,
    y: 349.981,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.902,
    height: 1.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.003,
    y: 348.02,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 11.769,
    height: 1.962
  })), /*#__PURE__*/React.createElement("rect", {
    x: 354.758,
    y: 354.508,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 10.26,
    height: 11.015
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M378.355,351.641 h-7.575c-1.45,0-2.625,1.175-2.625,2.625v13.972h12.825v-13.972C380.98,352.816,379.805,351.641,378.355,351.641z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.116,
    y: 349.981,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.902,
    height: 1.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.683,
    y: 348.02,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 11.769,
    height: 1.962
  })), /*#__PURE__*/React.createElement("rect", {
    x: 369.437,
    y: 354.508,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 10.26,
    height: 11.015
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M355.434,331.121 h-7.575c-1.45,0-2.625,1.175-2.625,2.625v13.972h12.825v-13.972C358.059,332.297,356.884,331.121,355.434,331.121z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.195,
    y: 329.461,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.902,
    height: 1.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.762,
    y: 327.5,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 11.769,
    height: 1.962
  })), /*#__PURE__*/React.createElement("rect", {
    x: 346.516,
    y: 333.988,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 10.26,
    height: 11.015
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M370.113,331.121 h-7.575c-1.45,0-2.625,1.175-2.625,2.625v13.972h12.825v-13.972C372.738,332.297,371.563,331.121,370.113,331.121z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.874,
    y: 329.461,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.902,
    height: 1.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.441,
    y: 327.5,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 11.769,
    height: 1.962
  })), /*#__PURE__*/React.createElement("rect", {
    x: 361.195,
    y: 333.988,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 10.26,
    height: 11.015
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M393.114,351.641 h-7.575c-1.45,0-2.625,1.175-2.625,2.625v13.972h12.825v-13.972C395.739,352.816,394.564,351.641,393.114,351.641z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.875,
    y: 349.981,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.902,
    height: 1.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.442,
    y: 348.02,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 11.769,
    height: 1.962
  })), /*#__PURE__*/React.createElement("rect", {
    x: 384.196,
    y: 354.508,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 10.26,
    height: 11.015
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M407.793,351.641 h-7.575c-1.45,0-2.625,1.175-2.625,2.625v13.972h12.825v-13.972C410.418,352.816,409.243,351.641,407.793,351.641z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.555,
    y: 349.981,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.902,
    height: 1.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.121,
    y: 348.02,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 11.769,
    height: 1.962
  })), /*#__PURE__*/React.createElement("rect", {
    x: 398.876,
    y: 354.508,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 10.26,
    height: 11.015
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M384.872,331.121 h-7.575c-1.45,0-2.625,1.175-2.625,2.625v13.972h12.825v-13.972C387.497,332.297,386.322,331.121,384.872,331.121z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.634,
    y: 329.461,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.902,
    height: 1.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.2,
    y: 327.5,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 11.769,
    height: 1.962
  })), /*#__PURE__*/React.createElement("rect", {
    x: 375.955,
    y: 333.988,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 10.26,
    height: 11.015
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M399.552,331.121 h-7.575c-1.45,0-2.625,1.175-2.625,2.625v13.972h12.825v-13.972C402.177,332.297,401.001,331.121,399.552,331.121z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.313,
    y: 329.461,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.902,
    height: 1.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.879,
    y: 327.5,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 11.769,
    height: 1.962
  })), /*#__PURE__*/React.createElement("rect", {
    x: 390.634,
    y: 333.988,
    style: {
      fill: "none",
      stroke: "#B2B2B2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 10.26,
    height: 11.015
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6FF00"
    },
    d: "M339.738,420.319c0,3.879-43.13,7.024-96.334,7.024c-53.204,0-96.334-3.145-96.334-7.024 c0-3.879,43.13-7.024,96.334-7.024C296.607,413.295,339.738,416.44,339.738,420.319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF"
    },
    d: "M339.738,420.319c0,3.879-43.13,7.024-96.334,7.024 c-53.204,0-96.334-3.145-96.334-7.024c0-3.879,43.13-7.024,96.334-7.024C296.607,413.295,339.738,416.44,339.738,420.319z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_153_",
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M259.656,130.022c0,0,3.386,4.867,3.597,9.099s0.212,7.829,0.846,9.31s2.751,2.539,2.539,3.809 c-0.212,1.27-1.904,2.539-1.904,2.539s-1.058,5.925-2.962,8.676c-1.905,2.751-4.444,1.693-6.56,1.481 c-2.116-0.212-3.809-0.846-3.809-0.846s-2.962,3.386-3.386,7.829c-0.423,4.444,0.212,6.983,0.212,6.983l-14.812-4.444 c0,0,6.983-5.713,6.137-12.484c-0.846-6.771-4.232-11.638-4.232-11.638s-7.829-8.676-4.867-13.754 c2.962-5.079,5.925-9.522,9.311-11.215C243.151,123.674,259.656,130.022,259.656,130.022z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_163_",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M256.694,152.875c0,0,2.962,2.962,4.867,3.386"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_164_",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 257.963,
    y1: 151.817,
    x2: 255.424,
    y2: 153.933
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_160_",
    style: {
      fill: "#263238"
    },
    cx: 261.243,
    cy: 146.421,
    rx: 0.952,
    ry: 2.433
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_170_",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M257.328,141.237c0,0,1.27-3.809,4.021-2.751"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_158_",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M227.704,131.927c0,0-1.058-6.348-9.734-6.348c-8.676,0-8.887,12.696-6.771,17.986c2.116,5.29,9.945,7.406,13.542,4.867 s4.02-6.983,4.02-9.099C228.762,137.217,227.704,131.927,227.704,131.927z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10_",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M242.093,148.008c0,0,9.31-1.058,10.792-4.867c1.481-3.809-1.481-6.348-1.904-7.406s9.311-0.635,11.003-8.887 c1.693-8.252-3.386-9.522-4.867-8.252s-1.481,6.56-1.481,6.56s-4.444-6.136-8.464-6.771c-4.02-0.635-4.655,0.846-3.597,2.328 c1.058,1.481,3.809,3.809,3.809,3.809s-11.638-4.867-17.351,1.481c-5.713,6.348-8.464,13.543-3.386,20.737 s11.85,10.157,11.85,10.157S238.919,150.759,242.093,148.008z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M243.363,149.49c0,0-1.693-7.194-4.444-3.597c-2.751,3.597-0.423,7.618,1.27,9.31c1.693,1.693,4.867,0.212,4.867,0.212"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_172_",
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M334.351,178.479c0,0,5.502,3.597,4.232,5.078c-1.27,1.481-4.867,3.597-4.867,3.597s-4.655-2.328-6.771-3.597 c-2.116-1.27,0.423-3.386,2.539-4.655C331.6,177.633,333.081,176.998,334.351,178.479z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_169_",
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M247.172,177.633c0,0,15.235,4.655,17.986,5.502c2.751,0.846,9.31,0.635,9.31,0.635s8.676-0.635,17.775-2.962 c9.099-2.328,27.508-3.174,27.508-3.174s8.887-2.328,13.754-1.693c4.867,0.635,13.119,1.693,13.119,1.693 s-1.481,1.27-3.809,1.693s-8.253-0.635-9.522-0.212c-1.27,0.423-2.751,2.328-2.751,2.328s4.232,3.809,4.232,4.867 c0,1.058-0.423,2.962-1.693,2.751c-1.27-0.212-1.27-1.481-2.962-2.328c-1.693-0.846-3.597-1.27-5.925-2.539 c-2.328-1.269-3.597-2.539-3.597-2.539c-0.346-0.346-11.311,5.324-12.587,5.86c-4.719,1.983-9.539,3.742-14.469,5.125 c-9.435,2.648-19.725,4.288-29.442,2.345c-6.348-1.27-16.928-4.867-16.928-4.867s-6.56-2.962-6.136-8.464 C241.458,176.151,247.172,177.633,247.172,177.633z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_161_",
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M251.404,182.711c0,0-5.502-9.31-10.792-11.85s-10.58,4.444-13.331,10.58c-2.751,6.137-2.328,15.658-1.693,24.546 c0.635,8.887,4.867,19.044,4.867,19.044s-9.099,11.003-11.215,21.372c-2.116,10.368,0.846,23.911,2.116,33.221 c1.27,9.31,1.904,24.757,1.904,24.757s-5.713,6.348-6.56,14.177c-0.846,7.829-3.788,41.645-3.788,45.665 c0,4.02-0.846,9.945,0,11.003c0.846,1.058,0.846,1.058,1.693,1.058c0.846,0,20.737-1.905,22.43-3.386 c1.693-1.481,2.539-2.539,0.635-3.386c-1.904-0.846-17.986-6.983-18.198-8.676c-0.212-1.693,15.003-39.529,17.543-46.3 c2.539-6.771,5.29-36.395,6.348-40.839s3.174-12.484,3.174-12.484s7.905-0.403,22.293-2.942 c14.389-2.539,27.884-9.446,27.884-9.446s-7.324,13.777-4.656,22.868s3.772,22.035,4.341,30.856 c0.569,8.821-0.609,8.029,0.569,8.821c1.178,0.792,9.802-3.216,12.192-3.548c2.39-0.332,11.055-1.348,13.844-3.122 c2.789-1.774-9.356-3.553-14.44-5.489c-5.084-1.936-5.369-3.039-5.369-3.039s-0.183-6.851,5.542-34.702 c2.855-13.888,4.114-25.285,0.418-26.402c-3.696-1.117-33.978-0.497-41.384,1.408c-7.406,1.904-11.713,6.539-11.713,6.539 s-3.386-14.6-2.962-19.891c0.423-5.29,1.27-12.273,1.27-12.273s6.348-2.328,6.137-7.829c-0.212-5.502-4.444-9.734-6.348-13.119 C252.25,186.52,251.404,182.711,251.404,182.711z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_167_",
    style: {
      fill: "#C6FF00",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M237.67,369.514c-1.63-0.724-13.637-5.322-17.199-7.694c-0.411,0.528-0.917,1.332-0.787,1.981 c0.212,1.058,1.27,3.386,1.27,3.386l-8.278,2.245c-0.166,2.715-0.276,5.153,0.237,5.796c0.846,1.058,0.846,1.058,1.693,1.058 c0.846,0,20.737-1.904,22.43-3.386C238.728,371.418,239.574,370.36,237.67,369.514z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_166_",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M305.626,277.678c0.769-4.387,1.779-9.72,3.112-16.206c2.855-13.888,4.114-25.285,0.418-26.402 c-3.696-1.117-33.978-0.497-41.384,1.408c-4.285,1.102-9.874,2.647-10.157,3.022c-0.477-2.11-4.558-10.014-4.553-15.36 c-8.924,0.566-17.061,1.127-17.529,1.314c-0.477,0.191-4.051,1.715-7.89,3.351c-2.858,4.108-7.052,10.975-8.403,17.598 c-2.116,10.369,0.846,23.911,2.116,33.221c1.27,9.31,1.904,24.757,1.904,24.757s-5.713,6.348-6.56,14.177 c-0.537,4.966-4.308,25.162-4.068,34.449c2.236,0.217,5.401,0.177,9.472-0.715c3.427-9.831,13.18-33.142,14.91-37.754 c2.539-6.771,5.29-36.395,6.348-40.839c1.058-4.444,3.174-12.484,3.174-12.484s7.905-0.403,22.293-2.942 c14.389-2.539,27.884-9.446,27.884-9.446s-7.324,13.777-4.656,22.868c0.675,2.302,1.25,4.851,1.741,7.516 C297.218,279.501,301.47,279.307,305.626,277.678z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_165_",
    style: {
      fill: "#C6FF00",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M253.096,223.127c0.423-5.29,1.27-12.273,1.27-12.273s6.348-2.328,6.136-7.829c-0.212-5.502-4.444-9.734-6.348-13.119 c-1.904-3.386-2.751-7.194-2.751-7.194s-5.502-9.31-10.792-11.85s-10.58,4.444-13.331,10.58 c-2.751,6.136-2.328,15.658-1.693,24.546c0.635,8.887,4.867,19.044,4.867,19.044s-7.218,8.744-10.287,17.987 c4.174,1.769,10.597,3.497,17.904,2.961c10.069-0.738,16.92-4.217,19.543-6.48 C256.644,234.779,252.815,226.644,253.096,223.127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M245.479,195.407 c0,0-5.364,4.093-15.364,6.093"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M246.115,197 c0,0-5,7-10.5,9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M229.96,238.714 c-1.078,0.631-2.194,1.229-3.345,1.786"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M251.115,218 c0,0-6.116,10.193-16.947,17.975"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_12_",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M265.369,142.41v4.733c0,0.495,0.367,0.914,0.858,0.979l29.495,3.91c0.59,0.078,1.114-0.379,1.117-0.973l0.052-9.437 c0.003-0.558-0.456-1.008-1.014-0.993l-29.548,0.793C265.795,141.437,265.369,141.875,265.369,142.41z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_159_",
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M274.468,153.298c0,0-5.713-1.481-6.136-3.174c-0.423-1.693-0.423-2.962-0.423-2.962s2.751,0.635,3.597,0.212 c0.846-0.423,0.212-12.273,1.27-12.908c1.058-0.635,4.444-2.116,5.713,0.846c1.27,2.962,0.423,2.116,0.423,2.116 s1.904-0.423,3.386,0c1.481,0.423,2.962,1.904,2.962,1.904s2.751-0.423,3.386,1.481c0.635,1.904-2.328,9.945-4.232,13.542 c-1.904,3.597-2.539,5.079-2.539,5.079s-2.539,31.74-4.02,37.876s-3.876,9.727-4.934,9.727c-1.058,0-19.823-8.669-27.44-11.632 s-12.699-2.195-13.969-9.813c-1.27-7.618,4.024-9.443,8.467-9.443c4.444,0,27.72,13.966,27.72,13.966 s7.406-22.007,7.406-27.931C275.103,156.261,274.468,153.298,274.468,153.298z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_168_",
    style: {
      fill: "#C6FF00",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M323.005,304.702c2.789-1.774-9.356-3.553-14.44-5.489c-2.138-0.814-3.42-1.478-4.196-1.978 c-0.433,0.516-0.785,1.183-0.712,1.985c0.176,1.943,0.799,3.73,0.799,3.73s-4.579,1.251-7.925,2.265 c0.196,5.982-0.604,5.456,0.438,6.157c1.178,0.792,9.802-3.216,12.192-3.548C311.551,307.492,320.216,306.476,323.005,304.702z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_162_",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 246.537,
    y1: 261.215,
    x2: 251.615,
    y2: 250
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_189_",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 289.931,
    cy: 411.381,
    r: 7.783
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_187_",
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M284.978,404.778c0,0,1.651,7.075,2.594,8.49c0.943,1.415,4.009,2.122,4.717-0.943c0.707-3.066-2.594-8.018-2.594-8.018 L284.978,404.778z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_192_",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 189.229,
    cy: 411.381,
    r: 7.783
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_191_",
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M194.182,404.778c0,0-1.651,7.075-2.594,8.49c-0.943,1.415-4.009,2.122-4.717-0.943c-0.708-3.066,2.594-8.018,2.594-8.018 L194.182,404.778z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M309.791,338.755c0.077-0.19,0.124-0.395,0.126-0.613c0.003-0.296-0.077-0.572-0.21-0.814l-1.599-27.219 c-0.045-0.762-0.6-1.397-1.35-1.543l-124.462-24.187l-1.988-10.557c-0.585-3.11-3.306-5.387-6.47-5.414l-23.036-0.2 c-0.005,0-0.01,0-0.015,0c-0.916,0-1.663,0.739-1.671,1.658c-0.008,0.923,0.734,1.678,1.657,1.686l23.036,0.2 c1.572,0.014,2.923,1.144,3.214,2.688l11.728,62.279c-0.003,0.04-0.013,0.079-0.013,0.12c-0.003,0.272,0.065,0.525,0.178,0.753 l7.482,39.731c-0.133,0.361-0.15,0.767-0.007,1.156c0.017,0.045,1.63,4.571-0.497,11.164 c-2.193,6.798-7.297,11.757-7.348,11.806c-0.274,0.263-0.411,0.602-0.466,0.95h-8.754c-0.924,0-1.672,0.749-1.672,1.672 c0,0.923,0.748,1.672,1.672,1.672h113.908c0.923,0,1.672-0.749,1.672-1.672c0-0.923-0.749-1.672-1.672-1.672h-51.326 c-0.988-3.072-2.165-9.9,1.73-13.349c6.887-6.099,8.958-13.232,9.539-16.082l56.615-8.059c0.862-0.123,1.485-0.885,1.434-1.753 L309.791,338.755z M256.075,369.177l-0.392-3.346l8.369-0.847l0.261,3.021L256.075,369.177z M243.991,370.897l-0.483-3.835 l8.847-0.895l0.408,3.481L243.991,370.897z M203.056,291.819l2.764,17.157l-9.757-0.983l-3.39-18.191L203.056,291.819z  M218.357,294.793l1.787,15.627l-10.881-1.097l-2.711-16.824L218.357,294.793z M231.362,297.32l1.813,14.413l-9.627-0.97 l-1.75-15.301L231.362,297.32z M244.583,299.889l1.542,13.149l-9.536-0.961l-1.772-14.085L244.583,299.889z M306.306,336.431 l-14.127-0.152c-0.384-5.506-0.754-10.813-1.068-15.348l14.37,1.448L306.306,336.431z M288.824,336.243l-10.386-0.112 l-1.127-16.591l10.424,1.051C288.057,325.244,288.437,330.698,288.824,336.243z M214.009,338.783l9.39,0.101l3.036,26.546 l-8.003,0.81L214.009,338.783z M215.1,366.576l-7.97,0.806l-5.354-28.731l8.84,0.095L215.1,366.576z M248.795,335.813 l-9.232-0.099l-2.546-20.233l9.506,0.958L248.795,335.813z M249.93,316.781l10.039,1.012l1.571,18.157l-9.374-0.101 L249.93,316.781z M236.189,335.677l-9.802-0.105l-2.449-21.41l9.666,0.974L236.189,335.677z M223.017,335.536l-9.547-0.103 l-3.656-22.695l10.72,1.08L223.017,335.536z M226.769,338.92l9.841,0.106l3.153,25.055l-10,1.012L226.769,338.92z  M239.985,339.062l9.203,0.099l2.777,23.686l-8.875,0.898L239.985,339.062z M252.559,339.197l9.271,0.1l1.934,22.356 l-8.47,0.857L252.559,339.197z M265.188,339.333l10.124,0.109l1.42,20.899l-9.642,0.975L265.188,339.333z M264.899,335.986 l-1.544-17.852l10.583,1.066l1.148,16.895L264.899,335.986z M277.081,316.158l-0.685-10.086l10.49,2.039 c0.088,1.394,0.313,4.702,0.616,9.098L277.081,316.158z M273.708,315.818l-10.646-1.073l-0.991-11.457l10.931,2.124 L273.708,315.818z M259.676,314.404l-10.145-1.022l-1.504-12.822l10.63,2.066L259.676,314.404z M206.371,312.391l3.706,23.005 l-8.925-0.096l-4.451-23.884L206.371,312.391z M197.744,335.264l-5.877-0.063l-4.659-24.741l6.027,0.607L197.744,335.264z  M198.369,338.615l5.424,29.105l-5.693,0.576l-5.601-29.745L198.369,338.615z M198.72,371.594l5.687-0.575l1.001,5.371 l-5.634,0.802L198.72,371.594z M208.721,375.918l-0.976-5.237l7.888-0.798l0.796,4.938L208.721,375.918z M219.74,374.349 l-0.774-4.804l7.85-0.794l0.517,4.517L219.74,374.349z M230.644,372.797l-0.501-4.383l10.038-1.016l0.5,3.97L230.644,372.797z  M267.378,364.648l9.58-0.969l0.17,2.502l-9.501,1.352L267.378,364.648z M280.286,363.342l10.363-1.048 c0.049,0.695,0.094,1.338,0.136,1.943l-10.338,1.472L280.286,363.342z M280.059,360.004l-1.394-20.527l10.393,0.112 c0.492,7.037,0.979,13.982,1.357,19.367L280.059,360.004z M292.412,339.626l14.09,0.151l1.025,17.448l-13.785,1.395 C293.333,352.794,292.869,346.157,292.412,339.626z M305.282,319l-14.406-1.452c-0.275-3.982-0.487-7.078-0.599-8.779 l14.57,2.831L305.282,319z M189.144,289.116l3.453,18.527l-6.034-0.608l-3.601-19.12L189.144,289.116z M241.42,386.546 c-4.815,4.265-4.112,11.648-2.992,15.853H192.23c1.852-2.111,5.108-6.346,6.844-11.729c1.376-4.265,1.4-7.797,1.129-10.162 l6.938-0.988c0.083,0.013,0.16,0.043,0.246,0.043c0.101,0,0.205-0.009,0.308-0.028c0.159-0.03,0.305-0.087,0.443-0.157 l41.481-5.905C248.833,376.396,246.743,381.831,241.42,386.546z M294.103,363.764c-0.041-0.589-0.084-1.192-0.127-1.808 l13.747-1.391l0.073,1.249L294.103,363.764z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_174_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M170.127,272.752h-24.291c-1.846,0-3.344-1.497-3.344-3.344c0-1.847,1.497-3.344,3.344-3.344h24.291 c1.846,0,3.344,1.497,3.344,3.344C173.47,271.255,171.973,272.752,170.127,272.752z"
  })))), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 207.76,
    y1: 143.565,
    x2: 187.729,
    y2: 143.565
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 166.696,
    y1: 180.71,
    x2: 160.966,
    y2: 180.71
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 219.314,
    y1: 180.71,
    x2: 174.316,
    y2: 180.71
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 180.008,
    y1: 293.014,
    x2: 117.539,
    y2: 293.014
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 156.845,
    y1: 304.947,
    x2: 130.173,
    y2: 304.947
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 215.613,
    y1: 249.374,
    x2: 192.642,
    y2: 249.374
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 292.312,
    y1: 274.063,
    x2: 274.063,
    y2: 274.063
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 283.188,
    y1: 269.851,
    x2: 258.621,
    y2: 269.851
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCart);
export default __webpack_public_path__ + "static/media/empty_cart.b64b9876082316d3199275a4ab719468.svg";
export { ForwardRef as ReactComponent };